import script from "./BillingMainPdf.vue?vue&type=script&lang=js"
export * from "./BillingMainPdf.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__